import { get } from 'lodash';
import GetRecord from '../../../lib/api/GetRecord';
import { APIS, METHOD_POST } from '../../../lib/constants/apis';
import { enumT, transformValues } from '../../../utils/helper';
import POP_LEVEL from '../../../lib/api/Populations.json';

import Schema from '../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import {
	STRAPI_URL,
	TEMPLATE_SERVICE_CLIENT_ID,
	TEMPLATE_SERVICE_PASSWORD,
	TEMPLATE_SERVICE_SERVER_ID,
	TEMPLATES_URL,
} from '../../../lib/constants/url';
import { getUserJwt } from '../../../context/AuthHelper';
import { TEMPLATES } from '../../../lib/constants/constant';
const P = Schema.attributes;

export const DownloadAntragPDF = async (
	application: any,
	readOnly: boolean,
	saveApplication: (submit: boolean, app: any) => void,
	imagePaths?: any[],
) => {
	const ImagesPaths = imagePaths || [];
	const appId = get(application, 'id');
	const templateURL = TEMPLATES_URL + TEMPLATES.Zuwendungsantrag;
	let images = [];
	if (!readOnly) {
		saveApplication(false, application);
	}

	let appRes = await GetRecord(APIS.Zuwendungsantrag, appId, POP_LEVEL.zuwendungsantrag.FULL);
	let res = transformValues(appRes, enumT);

	// Fetch all images and wait for all promises to resolve
	for (let item of ImagesPaths) {
		let eachImageARR = get(application, item, []);
		for (let eachImageField of eachImageARR) {
			let imageID = get(eachImageField, 'Zelle_1.id');
			let imageExt = get(eachImageField, 'Zelle_1.attributes.ext');
			let imageURL = get(eachImageField, 'Zelle_1.attributes.url');
			let downloadImageRes = await fetch(`${STRAPI_URL}${imageURL}`, {
				headers: {
					Authorization: `Bearer ${getUserJwt()}`,
				},
			});
			const blob = await downloadImageRes.blob();
			images.push({ id: imageID, ext: imageExt, imageFile: blob });
		}
	}

	// Convert the response object to a JSON string
	let jsonString = JSON.stringify(res);

	// Create a Blob from the JSON string
	let jsonBlob = new Blob([jsonString], { type: 'application/json' });

	let GetAppPDFData = new FormData();
	GetAppPDFData.append('data', jsonBlob, 'antrag_template_daten.json');

	// Append each image to the FormData object with a unique key
	images.forEach((image) => {
		GetAppPDFData.append(`images`, image.imageFile, `${image.id}${image.ext}`);
	});

	let pdfRes = await fetch(templateURL, {
		method: METHOD_POST,
		headers: {
			Authorization: 'Basic ' + btoa(TEMPLATE_SERVICE_PASSWORD),
			'X-Server-Id': TEMPLATE_SERVICE_SERVER_ID,
			'X-Client-Id': TEMPLATE_SERVICE_CLIENT_ID,
		},
		body: GetAppPDFData,
	});

	const blob = await pdfRes.blob();
	const objectUrl = URL.createObjectURL(blob);

	const link = document.createElement('a');
	link.href = objectUrl;
	link.download = `${enumT(get(application, P.Allgemein_Typ.path))}_${get(application, P.Allgemein_Projekttitel.path)}.pdf`;
	document.body.appendChild(link);
	link.click();
	link.remove();
	URL.revokeObjectURL(objectUrl);
};
